import BigNumber from "bignumber.js";

import { ZERO } from "lib/consts";

import {
  formatUsdValue,
  removeTrailingZeros,
  toFixedString,
} from "./formatNumber";

interface Params {
  value: string;
  exchangeRate?: string | null;
  accuracy?: number;
  accuracyUsd?: number;
  decimals?: string | null;
}

export default function getCurrencyValue({
  value,
  accuracy,
  accuracyUsd,
  decimals,
  exchangeRate,
}: Params) {
  const valueCurr = BigNumber(value).div(
    BigNumber(10 ** Number(decimals || "18")),
  );
  // const valueResult = toFixedString(accuracy ? valueCurr.dp(accuracy) : valueCurr, fixed);
  const valueResult = removeTrailingZeros(
    accuracy ? valueCurr.dp(accuracy).toFormat() : valueCurr.toFormat(),
  );

  let usdResult: string | undefined;
  let usdBn = ZERO;

  if (exchangeRate) {
    const exchangeRateBn = new BigNumber(exchangeRate);
    usdBn = valueCurr.times(exchangeRateBn);
    usdResult = formatUsdValue(usdBn, accuracyUsd);
  }

  return { valueStr: valueResult, usd: usdResult, usdBn };
}
